import PropTypes from 'prop-types';

export const props = {
  page: PropTypes.shape({}),
  settings: PropTypes.shape({ title: PropTypes.string }),
};
